/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
import { ferryFetch } from "@ecom-alliance/libs";
import * as api from "../../api";
import * as notification from "../data/notification";
export { api, notification };
import { method, headers, queryStringify } from "../../_util";
export var AffiliateNotificationApi = /*#__PURE__*/function () {
  function AffiliateNotificationApi(uriPrefix) {
    this.uriPrefix = typeof uriPrefix !== "undefined" ? uriPrefix : "";
  }
  var _proto = AffiliateNotificationApi.prototype;
  _proto.CreatorNotificationUnreadCount = function CreatorNotificationUnreadCount(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/unread_count";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.ListNotificationSubSchema = function ListNotificationSubSchema(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/list_schemas";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.ListCreatorNotification = function ListCreatorNotification(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/list" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetNotificationConfig = function GetNotificationConfig(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/config";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.SaveNotificationConfig = function SaveNotificationConfig(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/config";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.ListClassifyNotification = function ListClassifyNotification(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/classify/list" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.ListCreatorIMConversation = function ListCreatorIMConversation(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/im/list" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.MarkAsRead = function MarkAsRead(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/mark_as_read";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.MarkAsClicked = function MarkAsClicked(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/mark_as_clicked";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.ListNotificationGroupSchema = function ListNotificationGroupSchema(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/group/schemas";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.UpdateIMRelation = function UpdateIMRelation(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/im/relation/update";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.UpdateIMConversation = function UpdateIMConversation(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/im/conversation/update";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.ListIMSellerCategoryByCreator = function ListIMSellerCategoryByCreator(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/im/seller_category";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetCreatorEcPermission = function GetCreatorEcPermission(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/ec_permission";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetCreatorLatestNotification = function GetCreatorLatestNotification(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/get_latest_creator_notification";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetShopIMQuota = function GetShopIMQuota(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/im/shop_quota";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.CheckShopIMEntrance = function CheckShopIMEntrance(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/im/entrance_check";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetShopIMPermission = function GetShopIMPermission(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/im/permission";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  return AffiliateNotificationApi;
}();
export var affiliateNotificationApiClient = new AffiliateNotificationApi();